module.exports = __webpack_public_path__ + "static/media/NewEvent.8c93894c.png";